import { FIELD, REPEATER, UPLOAD } from '../constants/layoutComponentTypes';

const itemsWithKey = [FIELD, REPEATER, UPLOAD];

export default type => itemsWithKey.includes(type);
